import React from 'react';
import {
  Stack,
  Box,
} from '@mui/material';
import {
  Card, ContextMenu,
  ContextMenuButton,
  ContextMenuItem,
  ProfileCardContent,
  LabelAndValueElement,
  useCurrentTime,
  formatTimeWithTimeZoneName,
  ZAvatar,
} from '@marageti/z4-lib';
import { ProfileCardProps } from './types';
import styles from './styles';
import { getPhoneNumber } from '../../../utils/helpers';

const menuId = 'profile-context-menu';
const buttonId = 'profile-context-button';

const ProfileCard = ({
  contextMenuAnchor,
  contextMenuOpen,
  onCloseContextMenu,
  onEditAvatar,
  onOpenContextMenu,
  onOpenEditor,
  teamMember,
}: ProfileCardProps) => {
  const [time] = useCurrentTime(teamMember?.timeZone?.name);

  return (
    <Card sx={styles.profileCard}>
      <ProfileCardContent>
        <Box sx={styles.avatarBoxDesktop}>
          <ZAvatar
            name={teamMember?.fullName}
            size={128}
            loading={!teamMember}
            onEdit={onEditAvatar}
            src={teamMember?.avatar}
          />
        </Box>
        <Stack spacing="24px" width="100%">
          <Stack direction="row" justifyContent="space-between">
            <LabelAndValueElement
              title="Name"
              value={teamMember?.fullName}
              key="name"
            />
            <ContextMenuButton
              id={buttonId}
              open={contextMenuOpen}
              onClick={onOpenContextMenu}
              menuId={menuId}
            />
            <ContextMenu
              anchorEl={contextMenuAnchor}
              buttonId={buttonId}
              id={menuId}
              onClose={onCloseContextMenu}
              open={contextMenuOpen}
            >
              <ContextMenuItem onClick={onOpenEditor}>
                Edit
              </ContextMenuItem>
            </ContextMenu>
          </Stack>
          <LabelAndValueElement
            title="Email"
            value={teamMember?.email}
            key="email"
          />
          <LabelAndValueElement
            title="Phone"
            value={getPhoneNumber(teamMember)}
            key="phone"
          />
          <LabelAndValueElement
            title="Timezone"
            value={teamMember?.timeZone ? formatTimeWithTimeZoneName(teamMember?.timeZone, time) : '-'}
            key="timeZone"
          />
        </Stack>
      </ProfileCardContent>
    </Card>
  );
};

export default ProfileCard;
